import React from 'react';
import { useTranslation } from 'react-i18next';
import ItemMenu from 'components/ItemMenu';
import ItemMenuButton from 'components/ItemMenuButton';

interface Props {
  isOpen: boolean;
  handleClose: () => void;
}

const SurgeryInstrumentListItemMenu = ({ isOpen, handleClose }: Props) => {
  const { t } = useTranslation('briefing');

  const onOpenDetails = () => {
    // TODO
  };

  const onAddLotNumber = () => {
    // TODO
  };

  return (
    <>
      <ItemMenu isOpen={!!isOpen} handleClose={handleClose}>
        <ItemMenuButton
          label={t('briefingMaterials.surgeryMaterialItem.menu.openDetails')}
          icon="icon_search-content_16.svg"
          isInPopover
          handleClick={onOpenDetails}
        />

        <ItemMenuButton
          label={t('briefingMaterials.surgeryMaterialItem.menu.addLotNumber')}
          icon="icon_i-edit_16.svg"
          isInPopover
          handleClick={onAddLotNumber}
        />
      </ItemMenu>
    </>
  );
};

export default SurgeryInstrumentListItemMenu;
